<template>
  <div class="animated fadeIn">
    <div class="col-sm-12 col-md-12">
      <div class="card">
        <div class="card-body">
          <div id="titulo">
					  <div class="row">
						  <div class="col-sm-12 col-md-12">
								<h4>Editar Usuário</h4>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<input id="botaoSalvar" class="btn btn-success" type="submit" value="Salvar" v-on:click="salvar">
								<router-link id="btnNovoCliente" class="btn btn-warning" to="/usuarios">
									<span class="glyphicon glyphicon-back"></span> Fechar
								</router-link>
							</div>
						</div>
					</div>

					<input type="hidden" v-model="model.id" />
					<div class="row">
						<div class="form-group col-md-2">
							<label>Ativo:</label><br>
							<select class="form-control pula custom" v-model="model.ativo">
								<option value="false" label="Não">Não</option>
								<option value="true" label="Sim">Sim</option>
							</select>
						</div>
						<div class="form-group col-md-10">
							<label>Nome:</label><br>
              <input name="nome" v-validate="'required'" data-vv-delay="500" :class="{'input pula form-control': true, 'is-danger': errors.has('nome') }" v-model="model.nome" required="required" autofocus="autofocus" />

						</div>
					</div>
					<div class="row">
						<div class="form-group col-md-6">
							<label>Login:</label><br>
							<input class="pula form-control" v-model="model.login" />
						</div>
            <div class="form-group col-md-6">
              <label>Senha:</label><br>
              <input type="password" class="pula form-control" v-model="model.senha"  @change="modificarSenha" />
              <input type="hidden" v-model="model.modificaSenha" />
            </div>
					</div>
          <div class="row">
            <div class="form-group col-md-6">
              <label>Departamento:</label><br>
              <input class="pula form-control" v-model="model.departamento" />
            </div>
            <div class="form-group col-md-6">
              <label>Empresa:</label><br>
              <input class="pula form-control" v-model="model.empresa" />
            </div>
            
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <div class="card">
                <div class="card-header">
                  Sistema
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="form-group col-md-4">
                      <div class="form-check">
                        <label>
                          <input type="checkbox" id="checkbox" v-model="model.permissoes.acessar"><span class="label-text"> ACESSAR</span>
                        </label>
                      </div>
                      <div class="form-check">
                        <label>
                          <input type="checkbox" id="checkbox" v-model="model.permissoes.menuCadastros"><span class="label-text"> CADASTROS</span>
                        </label>
                      </div>
                      <div class="form-check">
                        <label>
                          <input type="checkbox" id="checkbox" v-model="model.permissoes.menuEstoque"><span class="label-text"> ESTOQUE</span>
                        </label>
                      </div>
                      <div class="form-check">
                        <label>
                          <input type="checkbox" id="checkbox" v-model="model.permissoes.menuBancos"><span class="label-text"> BANCOS</span>
                        </label>
                      </div>
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.menuFinanceiro"><span class="label-text"> FINANCEIRO</span>
                      </label>
                    </div>
                  </div>
                  <div class="form-group col-md-12">
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.menuCheques"><span class="label-text"> CHEQUES</span>
                      </label>
                    </div>
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.menuCompras"><span class="label-text"> COMPRAS</span>
                      </label>
                    </div>

                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.menuFiscal"><span class="label-text"> FISCAL</span>
                      </label>
                    </div>
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.sintegra"><span class="label-text"> SINTEGRA</span>
                      </label>
                    </div>
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.sped"><span class="label-text"> SPED</span>
                      </label>
                    </div>
                  </div>
                  <div class="form-group col-md-12">
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.configuracaoFiscalEditar"><span class="label-text"> CONFIGURACAO FISCAL</span>
                      </label>
                    </div>


                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.menuVendas"><span class="label-text"> VENDAS</span>
                      </label>
                    </div>
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.configuracaoVendasEditar"><span class="label-text"> CONFIGURACAO VENDAS</span>
                      </label>
                    </div>
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.configuracaoVendasMobileEditar"><span class="label-text"> CONFIGURACAO VENDAS MOBILE</span>
                      </label>
                    </div>


                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.menuSistema"><span class="label-text"> SISTEMA</span>
                      </label>
                    </div>
                  </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Clientes
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.clientesCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.clientesEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.clientesExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.clientesVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.clientesRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Fornecedores
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.fornecedoresCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.fornecedoresEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.fornecedoresExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.fornecedoresVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.fornecedoresRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>




            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Transportadores
                </div>
                <div class="card-body">  
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.transportadoresCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.transportadoresEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.transportadoresExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.transportadoresVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.transportadoresRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>


            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Veiculos
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.veiculosCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.veiculosEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.veiculosExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.veiculosVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.veiculosRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>




            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Vendedores
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendedoresCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendedoresEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendedoresExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendedoresVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendedoresRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>



            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Produtos
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>




            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Servicos
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.servicosCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.servicosEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.servicosExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.servicosVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.servicosRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
              



            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Depositos
                </div>
                <div class="card-body">
                  
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.depositosCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.depositosEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.depositosExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.depositosVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.depositosRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>




            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Movimento Estoque
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.movimentacaoEstoqueCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.movimentacaoEstoqueEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.movimentacaoEstoqueExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.movimentacaoEstoqueVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.movimentacaoEstoqueRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>







            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Balanco de Estoque
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.balancoEstoqueCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.balancoEstoqueEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.balancoEstoqueExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.balancoEstoqueVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.balancoEstoqueRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>






            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Financeiro
                </div>
                <div class="card-body">
                  
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.fluxoCaixaCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.fluxoCaixaEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.fluxoCaixaExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.fluxoCaixaVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.fluxoCaixaRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Contas a Pagar
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.contasPagarCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.contasPagarEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.contasPagarExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.contasPagarVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.contasPagarRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Financeiro
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.contasReceberCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.contasReceberEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.contasReceberExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.contasReceberVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.contasReceberRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>








            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Bancos
                </div>
                <div class="card-body">
                  
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.bancosCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.bancosEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.bancosExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.bancosVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.bancosRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>









            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Movimento Banco
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.movimentacaoBancariaCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.movimentacaoBancariaEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.movimentacaoBancariaExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.movimentacaoBancariaVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.movimentacaoBancariaRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>









            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Movimentacao Boletos
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.movimentacaoBoletosCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.movimentacaoBoletosEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.movimentacaoBoletosExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.movimentacaoBoletosVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.movimentacaoBoletosRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>










            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Cheques Emitidos
                </div>
                <div class="card-body">
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.chequesEmitidosCadastrar"><span class="label-text"> CADASTRAR</span>
                      </label>
                    </div>
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.chequesEmitidosEditar"><span class="label-text"> EDITAR</span>
                      </label>
                    </div>
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.chequesEmitidosExcluir"><span class="label-text"> EXCLUIR</span>
                      </label>
                    </div>
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.chequesEmitidosVisualizar"><span class="label-text"> VISUALIZAR</span>
                      </label>
                    </div>
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.chequesEmitidosRelatorios"><span class="label-text"> RELATORIOS</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group col-md-4">
                <div class="card">
                  <div class="card-header">
                    Cheques Repasse
                  </div>
                  <div class="card-body">
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.chequesRepasseCadastrar"><span class="label-text"> CADASTRAR</span>
                      </label>
                    </div>
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.chequesRepasseEditar"><span class="label-text"> EDITAR</span>
                      </label>
                    </div>
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.chequesRepasseExcluir"><span class="label-text"> EXCLUIR</span>
                      </label>
                    </div>
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.chequesRepasseVisualizar"><span class="label-text"> VISUALIZAR</span>
                      </label>
                    </div>
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.chequesRepasseRelatorios"><span class="label-text"> RELATORIOS</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>



              <div class="form-group col-md-4">
                <div class="card">
                  <div class="card-header">
                    Cheque Status
                  </div>
                  <div class="card-body">
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.statusChequeCadastrar"><span class="label-text"> CADASTRAR</span>
                      </label>
                    </div>
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.statusChequeEditar"><span class="label-text"> EDITAR</span>
                      </label>
                    </div>
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.statusChequeExcluir"><span class="label-text"> EXCLUIR</span>
                      </label>
                    </div>
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.statusChequeVisualizar"><span class="label-text"> VISUALIZAR</span>
                      </label>
                    </div>
                    <div class="form-check">
                      <label>
                        <input type="checkbox" id="checkbox" v-model="model.permissoes.statusChequeRelatorios"><span class="label-text"> RELATORIOS</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>










            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Compras
                </div>
                <div class="card-body">
                  
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.comprasCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.comprasEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.comprasConfirmar"><span class="label-text"> CONFIRMAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.comprasCancelar"><span class="label-text"> CANCELAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.comprasVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.comprasRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>









            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Analise de Compra
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.analiseCompraCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.analiseCompraEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.analiseCompraConfirmar"><span class="label-text"> CONFIRMAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.analiseCompraCancelar"><span class="label-text"> CANCELAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.analiseCompraVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.analiseCompraRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>







            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Cotacao de Compras
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.cotacaoCompraCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.cotacaoCompraEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.cotacaoCompraConfirmar"><span class="label-text"> CONFIRMAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.cotacaoCompraCancelar"><span class="label-text"> CANCELAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.cotacaoCompraVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.cotacaoCompraRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>








            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Vendas de Produtos
                </div>
                <div class="card-body">
                  
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendasProdutosCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendasProdutosEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendasProdutosConfirmar"><span class="label-text"> CONFIRMAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendasProdutosCancelar"><span class="label-text"> CANCELAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendasProdutosVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendasProdutosRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>










            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Devolucao de Produtos
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.devolucaoProdutosCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.devolucaoProdutosEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.devolucaoProdutosConfirmar"><span class="label-text"> CONFIRMAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.devolucaoProdutosCancelar"><span class="label-text"> CANCELAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.devolucaoProdutosVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.devolucaoProdutosRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>








            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Vendas de Servicos
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendasServicosCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendasServicosEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendasServicosConfirmar"><span class="label-text"> CONFIRMAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendasServicosCancelar"><span class="label-text"> CANCELAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendasServicosVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendasServicosRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>










            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Vendas PDV
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendasProdutosPdvCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendasProdutosPdvEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendasProdutosPdvConfirmar"><span class="label-text"> CONFIRMAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendasProdutosPdvCancelar"><span class="label-text"> CANCELAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendasProdutosPdvVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.vendasProdutosPdvRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                  
                </div>
              </div>
            </div>









            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  NFE
                </div>
                <div class="card-body">
                  
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.nfeCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.nfeEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.nfeEnviar"><span class="label-text"> ENVIAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.nfeCancelar"><span class="label-text"> CANCELAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.nfeEventos"><span class="label-text"> EVENTOS</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.nfeVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.nfeRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>








            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  NFCE
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.nfceCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.nfceEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.nfceEnviar"><span class="label-text"> ENVIAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.nfceCancelar"><span class="label-text"> CANCELAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.nfceEventos"><span class="label-text"> EVENTOS</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.nfceVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.nfceRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>










            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  NFSE
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.nfseCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.nfseEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.nfseEnviar"><span class="label-text"> ENVIAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.nfseCancelar"><span class="label-text"> CANCELAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.nfseEventos"><span class="label-text"> EVENTOS</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.nfseVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.nfseRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>










            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  MDFE
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mdfeCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mdfeEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mdfeEnviar"><span class="label-text"> ENVIAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mdfeCancelar"><span class="label-text"> CANCELAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mdfeEventos"><span class="label-text"> EVENTOS</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mdfeVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mdfeRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>








            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  CTE
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.cteCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.cteEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.cteEnviar"><span class="label-text"> ENVIAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.cteCancelar"><span class="label-text"> CANCELAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.cteEventos"><span class="label-text"> EVENTOS</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.cteVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.cteRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>










            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Guia de Trafego
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.guiaTrafegoCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.guiaTrafegoEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.guiaTrafegoEnviar"><span class="label-text"> ENVIAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.guiaTrafegoCancelar"><span class="label-text"> CANCELAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.guiaTrafegoEventos"><span class="label-text"> EVENTOS</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.guiaTrafegoVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.guiaTrafegoRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            

            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Mensagens NFE
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mensagensNfeCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mensagensNfeEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mensagensNfeExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mensagensNfeVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mensagensNfeRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Mensagens NFSE
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mensagensNfseCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mensagensNfseEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mensagensNfseExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mensagensNfseVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mensagensNfseRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>


            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Mensagens MDFE
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mensagensMdfeCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mensagensMdfeEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mensagensMdfeExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mensagensMdfeVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mensagensMdfeRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Mensagens CTE
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mensagensCteCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mensagensCteEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mensagensCteExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mensagensCteVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.mensagensCteRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>



             









            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Formas de Pagamento
                </div>
                <div class="card-body">
                  
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.formasPagamentoCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.formasPagamentoEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.formasPagamentoExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.formasPagamentoVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.formasPagamentoRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>










            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Codigos NCM
                </div>
                <div class="card-body">

                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.codigosNcmsCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.codigosNcmsEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.codigosNcmsExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.codigosNcmsVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.codigosNcmsRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>











            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Cidades
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.cidadesCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.cidadesEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.cidadesExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.cidadesVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.cidadesRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>






            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Centros de Custos
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.centrosCustosCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.centrosCustosEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.centrosCustosExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.centrosCustosVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.centrosCustosRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>





            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Conceitos
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.conceitosCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.conceitosEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.conceitosExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.conceitosVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.conceitosRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>








            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Contas Caixa
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.contasCaixaCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.contasCaixaEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.contasCaixaExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.contasCaixaVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.contasCaixaRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>








            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Codigos CFOP
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.codigoCfopCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.codigoCfopEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.codigoCfopExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.codigoCfopVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.codigoCfopRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>







            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Codigos CFOP Regras
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.codigoCfopRegrasCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.codigoCfopRegrasEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.codigoCfopRegrasExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.codigoCfopRegrasVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.codigoCfopRegrasRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>









            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Planos de Contas
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.planosContasCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.planosContasEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.planosContasExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.planosContasVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.planosContasRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>








            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Marcas
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosMarcasCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosMarcasEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosMarcasExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosMarcasVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosMarcasRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>









            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Grupos
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosGruposCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosGruposEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosGruposExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosGruposVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosGruposRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>








            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Sub Grupos
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosSubGruposCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosSubGruposEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosSubGruposExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosSubGruposVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosSubGruposRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>








            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Cores
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosCoresCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosCoresEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosCoresExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosCoresVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosCoresRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>










            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Tamanhos
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosTamanhosCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosTamanhosEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosTamanhosExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosTamanhosVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosTamanhosRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>









            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Unidades
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosUnidadesCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosUnidadesEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosUnidadesExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosUnidadesVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosUnidadesRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>








            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Departamentos
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosDepartamentosCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosDepartamentosEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosDepartamentosExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosDepartamentosVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosDepartamentosRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>













            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Tabelas de Preços
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosTabelasPrecosCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosTabelasPrecosEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosTabelasPrecosExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosTabelasPrecosVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.produtosTabelasPrecosRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>








            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Unidade de Negócio
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.unidadesNegocioCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.unidadesNegocioEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.unidadesNegocioExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.unidadesNegocioVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.unidadesNegocioRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>











            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Tipo de Contato
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.tiposContatosCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.tiposContatosEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.tiposContatosExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.tiposContatosVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.tiposContatosRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>









            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Tipos Enderecos
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.tiposEnderecosCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.tiposEnderecosEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.tiposEnderecosExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.tiposEnderecosVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.tiposEnderecosRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>











            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Tipos Interacoes
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.tiposInteracoesCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.tiposInteracoesEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.tiposInteracoesExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.tiposInteracoesVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.tiposInteracoesRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>










            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Motivos Cancelamento
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.motivosCancelamentoCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.motivosCancelamentoEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.motivosCancelamentoExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.motivosCancelamentoVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.motivosCancelamentoRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>












            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Motivos Devolucoes
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.motivosDevolucaoCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.motivosDevolucaoEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.motivosDevolucaoExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.motivosDevolucaoVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.motivosDevolucaoRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>







            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Motivos Interacoes
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.motivosInteracoesCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.motivosInteracoesEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.motivosInteracoesExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.motivosInteracoesVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.motivosInteracoesRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>








            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Usuários
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.usuarioCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.usuarioEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.usuarioExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.usuarioVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.usuarioRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>







            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Empresa
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.empresaCadastrar"><span class="label-text"> CADASTRAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.empresaEditar"><span class="label-text"> EDITAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.empresaExcluir"><span class="label-text"> EXCLUIR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.empresaVisualizar"><span class="label-text"> VISUALIZAR</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.empresaRelatorios"><span class="label-text"> RELATORIOS</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group col-md-4">
              <div class="card">
                <div class="card-header">
                  Parametros
                </div>
                <div class="card-body">
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.parametroBloquearPrecoVenda"><span class="label-text"> Bloquear Preço Venda</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <label>
                      <input type="checkbox" id="checkbox" v-model="model.permissoes.parametroBloquearPrecoPedido"><span class="label-text"> Bloquear Preço Pedido</span>
                    </label>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>

	       

					<!-- div id="servicosCompostos" class="row">
						<div class="col-md-12 ">
							<div class="pull-right">
								<button id="adicionar" class="btn btn-info" type="button">Adicionar Serviço</button>
							</div>
            </div>

						<div class="row">
							<div class="col-md-12">
								<table id="tableServicosCompostos"
									class="responsive datatable_ajax display table table-striped table-hover"
									width="100%">

									<th>Serviço</th>
									<th>Quantidade</th>
									<th>Valor Unitário</th>
									<th>Valor Total</th>
                  <tr v-for="servico in model.servicosCompoe">
                    <td></td>
										<td></td>
										<td></td>
										<td></td>
										<td></td>
									</tr>
								</table>
							</div>
						</div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      model: {
        id: '0',
        ativo: true,
        nome: '',
        login: '',
        modificaSenha: false,
        senha: '',
        empresa: '0',
        departamento: '0',
        role: 'ROLE_ADMIN',
        dataCadastro: this.dataHoraAtual(),
        dataHoraUltimoAcesso: this.dataHoraAtual(),
        permissoes: {
          acessar: false,
          menuCadastros: '',
          menuEstoque: '',
          menuFinanceiro: '',
          menuBancos: '',
          menuCheques: '',
          menuCompras: '',
          menuVendas: '',
          menuFiscal: '',
          configuracaoFiscalEditar: '',
          menuSistema: '',
          sintegra: '',
          sped: '',
          clientesCadastrar: '',
          clientesEditar: '',
          clientesExcluir: '',
          clientesVisualizar: '',
          clientesRelatorios: '',
          fornecedoresCadastrar: '',
          fornecedoresEditar: '',
          fornecedoresExcluir: '',
          fornecedoresVisualizar: '',
          fornecedoresRelatorios: '',
          transportadoresCadastrar: '',
          transportadoresEditar: '',
          transportadoresExcluir: '',
          transportadoresVisualizar: '',
          transportadoresRelatorios: '',
          veiculosCadastrar: '',
          veiculosEditar: '',
          veiculosExcluir: '',
          veiculosVisualizar: '',
          veiculosRelatorios: '',
          vendedoresCadastrar: '',
          vendedoresEditar: '',
          vendedoresExcluir: '',
          vendedoresVisualizar: '',
          vendedoresRelatorios: '',
          produtosCadastrar: '',
          produtosEditar: '',
          produtosExcluir: '',
          produtosVisualizar: '',
          produtosRelatorios: '',
          servicosCadastrar: '',
          servicosEditar: '',
          servicosExcluir: '',
          servicosVisualizar: '',
          servicosRelatorios: '',
          depositosCadastrar: '',
          depositosEditar: '',
          depositosExcluir: '',
          depositosVisualizar: '',
          depositosRelatorios: '',
          movimentacaoEstoqueCadastrar: '',
          movimentacaoEstoqueEditar: '',
          movimentacaoEstoqueExcluir: '',
          movimentacaoEstoqueVisualizar: '',
          movimentacaoEstoqueRelatorios: '',
          balancoEstoqueCadastrar: '',
          balancoEstoqueEditar: '',
          balancoEstoqueExcluir: '',
          balancoEstoqueVisualizar: '',
          balancoEstoqueRelatorios: '',
          fluxoCaixaCadastrar: '',
          fluxoCaixaEditar: '',
          fluxoCaixaExcluir: '',
          fluxoCaixaVisualizar: '',
          fluxoCaixaRelatorios: '',
          contasPagarCadastrar: '',
          contasPagarEditar: '',
          contasPagarExcluir: '',
          contasPagarVisualizar: '',
          contasPagarRelatorios: '',
          contasReceberCadastrar: '',
          contasReceberEditar: '',
          contasReceberExcluir: '',
          contasReceberVisualizar: '',
          contasReceberRelatorios: '',
          bancosCadastrar: '',
          bancosEditar: '',
          bancosExcluir: '',
          bancosVisualizar: '',
          bancosRelatorios: '',
          movimentacaoBancariaCadastrar: '',
          movimentacaoBancariaEditar: '',
          movimentacaoBancariaExcluir: '',
          movimentacaoBancariaVisualizar: '',
          movimentacaoBancariaRelatorios: '',
          movimentacaoBoletosCadastrar: '',
          movimentacaoBoletosEditar: '',
          movimentacaoBoletosExcluir: '',
          movimentacaoBoletosVisualizar: '',
          movimentacaoBoletosRelatorios: '',
          chequesEmitidosCadastrar: '',
          chequesEmitidosEditar: '',
          chequesEmitidosExcluir: '',
          chequesEmitidosVisualizar: '',
          chequesEmitidosRelatorios: '',
          chequesRepasseCadastrar: '',
          chequesRepasseEditar: '',
          chequesRepasseExcluir: '',
          chequesRepasseVisualizar: '',
          chequesRepasseRelatorios: '',
          statusChequeCadastrar: '',
          statusChequeEditar: '',
          statusChequeExcluir: '',
          statusChequeVisualizar: '',
          statusChequeRelatorios: '',
          comprasCadastrar: '',
          comprasEditar: '',
          comprasConfirmar: '',
          comprasCancelar: '',
          comprasVisualizar: '',
          comprasRelatorios: '',
          analiseCompraCadastrar: '',
          analiseCompraEditar: '',
          analiseCompraConfirmar: '',
          analiseCompraCancelar: '',
          analiseCompraVisualizar: '',
          analiseCompraRelatorios: '',
          cotacaoCompraCadastrar: '',
          cotacaoCompraEditar: '',
          cotacaoCompraConfirmar: '',
          cotacaoCompraCancelar: '',
          cotacaoCompraVisualizar: '',
          cotacaoCompraRelatorios: '',
          vendasProdutosCadastrar: '',
          vendasProdutosEditar: '',
          vendasProdutosConfirmar: '',
          vendasProdutosCancelar: '',
          vendasProdutosVisualizar: '',
          vendasProdutosRelatorios: '',
          devolucaoProdutosCadastrar: '',
          devolucaoProdutosEditar: '',
          devolucaoProdutosConfirmar: '',
          devolucaoProdutosCancelar: '',
          devolucaoProdutosVisualizar: '',
          devolucaoProdutosRelatorios: '',
          vendasServicosCadastrar: '',
          vendasServicosEditar: '',
          vendasServicosConfirmar: '',
          vendasServicosCancelar: '',
          vendasServicosVisualizar: '',
          vendasServicosRelatorios: '',
          vendasProdutosPdvCadastrar: '',
          vendasProdutosPdvEditar: '',
          vendasProdutosPdvConfirmar: '',
          vendasProdutosPdvCancelar: '',
          vendasProdutosPdvVisualizar: '',
          vendasProdutosPdvRelatorios: '',
          configuracaoVendasEditar: '',
          configuracaoVendasMobileEditar: '',
          nfeCadastrar: '',
          nfeEditar: '',
          nfeEnviar: '',
          nfeCancelar: '',
          nfeEventos: '',
          nfeVisualizar: '',
          nfeRelatorios: '',
          nfceCadastrar: '',
          nfceEditar: '',
          nfceEnviar: '',
          nfceCancelar: '',
          nfceEventos: '',
          nfceVisualizar: '',
          nfceRelatorios: '',
          nfseCadastrar: '',
          nfseEditar: '',
          nfseEnviar: '',
          nfseCancelar: '',
          nfseEventos: '',
          nfseVisualizar: '',
          nfseRelatorios: '',
          mdfeCadastrar: '',
          mdfeEditar: '',
          mdfeEnviar: '',
          mdfeCancelar: '',
          mdfeEventos: '',
          mdfeVisualizar: '',
          mdfeRelatorios: '',
          cteCadastrar: '',
          cteEditar: '',
          cteEnviar: '',
          cteCancelar: '',
          cteEventos: '',
          cteVisualizar: '',
          cteRelatorios: '',
          guiaTrafegoCadastrar: '',
          guiaTrafegoEditar: '',
          guiaTrafegoEnviar: '',
          guiaTrafegoCancelar: '',
          guiaTrafegoEventos: '',
          guiaTrafegoVisualizar: '',
          guiaTrafegoRelatorios: '',
          mensagensNfeCadastrar: '',
          mensagensNfeEditar: '',
          mensagensNfeExcluir: '',
          mensagensNfeVisualizar: '',
          mensagensNfeRelatorios: '',
          mensagensNfceCadastrar: '',
          mensagensNfceEditar: '',
          mensagensNfceExcluir: '',
          mensagensNfceVisualizar: '',
          mensagensNfceRelatorios: '',
          mensagensNfseCadastrar: '',
          mensagensNfseEditar: '',
          mensagensNfseExcluir: '',
          mensagensNfseVisualizar: '',
          mensagensNfseRelatorios: '',
          mensagensMdfeCadastrar: '',
          mensagensMdfeEditar: '',
          mensagensMdfeExcluir: '',
          mensagensMdfeVisualizar: '',
          mensagensMdfeRelatorios: '',
          mensagensCteCadastrar: '',
          mensagensCteEditar: '',
          mensagensCteExcluir: '',
          mensagensCteVisualizar: '',
          mensagensCteRelatorios: '',
          formasPagamentoCadastrar: '',
          formasPagamentoEditar: '',
          formasPagamentoExcluir: '',
          formasPagamentoVisualizar: '',
          formasPagamentoRelatorios: '',
          codigosNcmsCadastrar: '',
          codigosNcmsEditar: '',
          codigosNcmsExcluir: '',
          codigosNcmsVisualizar: '',
          codigosNcmsRelatorios: '',
          cidadesCadastrar: '',
          cidadesEditar: '',
          cidadesExcluir: '',
          cidadesVisualizar: '',
          cidadesRelatorios: '',
          centrosCustosCadastrar: '',
          centrosCustosEditar: '',
          centrosCustosExcluir: '',
          centrosCustosVisualizar: '',
          centrosCustosRelatorios: '',
          conceitosCadastrar: '',
          conceitosEditar: '',
          conceitosExcluir: '',
          conceitosVisualizar: '',
          conceitosRelatorios: '',
          contasCaixaCadastrar: '',
          contasCaixaEditar: '',
          contasCaixaExcluir: '',
          contasCaixaVisualizar: '',
          contasCaixaRelatorios: '',
          codigoCfopCadastrar: '',
          codigoCfopEditar: '',
          codigoCfopExcluir: '',
          codigoCfopVisualizar: '',
          codigoCfopRelatorios: '',
          codigoCfopRegrasCadastrar: '',
          codigoCfopRegrasEditar: '',
          codigoCfopRegrasExcluir: '',
          codigoCfopRegrasVisualizar: '',
          codigoCfopRegrasRelatorios: '',
          planosContasCadastrar: '',
          planosContasEditar: '',
          planosContasExcluir: '',
          planosContasVisualizar: '',
          planosContasRelatorios: '',
          produtosMarcasCadastrar: '',
          produtosMarcasEditar: '',
          produtosMarcasExcluir: '',
          produtosMarcasVisualizar: '',
          produtosMarcasRelatorios: '',
          produtosGruposCadastrar: '',
          produtosGruposEditar: '',
          produtosGruposExcluir: '',
          produtosGruposVisualizar: '',
          produtosGruposRelatorios: '',
          produtosSubGruposCadastrar: '',
          produtosSubGruposEditar: '',
          produtosSubGruposExcluir: '',
          produtosSubGruposVisualizar: '',
          produtosSubGruposRelatorios: '',
          produtosCoresCadastrar: '',
          produtosCoresEditar: '',
          produtosCoresExcluir: '',
          produtosCoresVisualizar: '',
          produtosCoresRelatorios: '',
          produtosTamanhosCadastrar: '',
          produtosTamanhosEditar: '',
          produtosTamanhosExcluir: '',
          produtosTamanhosVisualizar: '',
          produtosTamanhosRelatorios: '',
          produtosUnidadesCadastrar: '',
          produtosUnidadesEditar: '',
          produtosUnidadesExcluir: '',
          produtosUnidadesVisualizar: '',
          produtosUnidadesRelatorios: '',
          produtosDepartamentosCadastrar: '',
          produtosDepartamentosEditar: '',
          produtosDepartamentosExcluir: '',
          produtosDepartamentosVisualizar: '',
          produtosDepartamentosRelatorios: '',
          produtosTabelasPrecosCadastrar: '',
          produtosTabelasPrecosEditar: '',
          produtosTabelasPrecosExcluir: '',
          produtosTabelasPrecosVisualizar: '',
          produtosTabelasPrecosRelatorios: '',
          unidadesNegocioCadastrar: '',
          unidadesNegocioEditar: '',
          unidadesNegocioExcluir: '',
          unidadesNegocioVisualizar: '',
          unidadesNegocioRelatorios: '',
          tiposContatosCadastrar: '',
          tiposContatosEditar: '',
          tiposContatosExcluir: '',
          tiposContatosVisualizar: '',
          tiposContatosRelatorios: '',
          tiposEnderecosCadastrar: '',
          tiposEnderecosEditar: '',
          tiposEnderecosExcluir: '',
          tiposEnderecosVisualizar: '',
          tiposEnderecosRelatorios: '',
          tiposInteracoesCadastrar: '',
          tiposInteracoesEditar: '',
          tiposInteracoesExcluir: '',
          tiposInteracoesVisualizar: '',
          tiposInteracoesRelatorios: '',
          motivosCancelamentoCadastrar: '',
          motivosCancelamentoEditar: '',
          motivosCancelamentoExcluir: '',
          motivosCancelamentoVisualizar: '',
          motivosCancelamentoRelatorios: '',
          motivosDevolucaoCadastrar: '',
          motivosDevolucaoEditar: '',
          motivosDevolucaoExcluir: '',
          motivosDevolucaoVisualizar: '',
          motivosDevolucaoRelatorios: '',
          motivosInteracoesCadastrar: '',
          motivosInteracoesEditar: '',
          motivosInteracoesExcluir: '',
          motivosInteracoesVisualizar: '',
          motivosInteracoesRelatorios: '',
          usuarioCadastrar: '',
          usuarioEditar: '',
          usuarioExcluir: '',
          usuarioVisualizar: '',
          usuarioRelatorios: '',
          empresaCadastrar: '',
          empresaEditar: '',
          empresaExcluir: '',
          empresaVisualizar: '',
          empresaRelatorios: '',
          parametroBloquearPrecoVenda: '',
          parametroBloquearPrecoPedido: ''
        }
      }
    }
  },
  created: function () {
    this.buscar()
    this.buscarPermissoes()
  },
  mounted: function () {
    $('.pula').keypress(function (e) {
      var tecla = (e.keyCode ? e.keyCode : e.which)
      if (tecla === 13) {
        let campo = $('.pula')
        let indice = campo.index(this)
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus()
        }
        if (campo[indice + 1] != null) {
          let proximo = campo[indice + 1]
          proximo.focus()
        }
        e.preventDefault(e)
        return false
      }
    })
  },
  methods: {
    buscar: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/usuarios/' + this.$route.params.id
      axios.get(url, config)
      .then(function (response) {
        var dados = response.data
        self.model.id = dados.id
        self.model.ativo = dados.ativo
        self.model.nome = dados.nome
        self.model.login = dados.login
        self.model.senha = dados.senha
        self.model.role = 'ROLE_ADMIN'
        self.model.departamento = dados.departamento
        self.model.empresa = dados.empresa
        self.model.dataCadastro = '01/01/2018'
        self.model.dataHoraUltimoAcesso = '01/01/2018 12:00:00'
      })
    },
    buscarPermissoes: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/usuarios/permissoes/' + this.$route.params.id
      axios.get(url, config)
      .then(function (response) {
        var dados = response.data
        self.model.permissoes.acessar = dados.includes('ROLE_ACESSAR')
        self.model.permissoes.menuCadastros = dados.includes('ROLE_MENU_CADASTROS')
        self.model.permissoes.menuEstoque = dados.includes('ROLE_MENU_ESTOQUE')
        self.model.permissoes.menuFinanceiro = dados.includes('ROLE_MENU_FINANCEIRO')
        self.model.permissoes.menuBancos = dados.includes('ROLE_MENU_BANCOS')
        self.model.permissoes.menuCheques = dados.includes('ROLE_MENU_CHEQUES')
        self.model.permissoes.menuCompras = dados.includes('ROLE_MENU_COMPRAS')
        self.model.permissoes.menuVendas = dados.includes('ROLE_MENU_VENDAS')
        self.model.permissoes.menuFiscal = dados.includes('ROLE_MENU_FISCAL')
        self.model.permissoes.configuracaoFiscalEditar = dados.includes('ROLE_CONFIGURACAO_FISCAL_EDITAR')
        self.model.permissoes.menuSistema = dados.includes('ROLE_MENU_SISTEMA')
        self.model.permissoes.sintegra = dados.includes('ROLE_SINTEGRA')
        self.model.permissoes.sped = dados.includes('ROLE_SPED')

        self.model.permissoes.clientesCadastrar = dados.includes('ROLE_CLIENTES_CADASTRAR')
        self.model.permissoes.clientesEditar = dados.includes('ROLE_CLIENTES_EDITAR')
        self.model.permissoes.clientesExcluir = dados.includes('ROLE_CLIENTES_EXCLUIR')
        self.model.permissoes.clientesVisualizar = dados.includes('ROLE_CLIENTES_VISUALIZAR')
        self.model.permissoes.clientesRelatorios = dados.includes('ROLE_CLIENTES_RELATORIOS')
        self.model.permissoes.fornecedoresCadastrar = dados.includes('ROLE_FORNECEDORES_CADASTRAR')
        self.model.permissoes.fornecedoresEditar = dados.includes('ROLE_FORNECEDORES_EDITAR')
        self.model.permissoes.fornecedoresExcluir = dados.includes('ROLE_FORNECEDORES_EXCLUIR')
        self.model.permissoes.fornecedoresVisualizar = dados.includes('ROLE_FORNECEDORES_VISUALIZAR')
        self.model.permissoes.fornecedoresRelatorios = dados.includes('ROLE_FORNECEDORES_RELATORIOS')
        self.model.permissoes.transportadoresCadastrar = dados.includes('ROLE_TRANSPORTADORES_CADASTRAR')
        self.model.permissoes.transportadoresEditar = dados.includes('ROLE_TRANSPORTADORES_EDITAR')
        self.model.permissoes.transportadoresExcluir = dados.includes('ROLE_TRANSPORTADORES_EXCLUIR')
        self.model.permissoes.transportadoresVisualizar = dados.includes('ROLE_TRANSPORTADORES_VISUALIZAR')
        self.model.permissoes.transportadoresRelatorios = dados.includes('ROLE_TRANSPORTADORES_RELATORIOS')
        self.model.permissoes.veiculosCadastrar = dados.includes('ROLE_VEICULOS_CADASTRAR')
        self.model.permissoes.veiculosEditar = dados.includes('ROLE_VEICULOS_EDITAR')
        self.model.permissoes.veiculosExcluir = dados.includes('ROLE_VEICULOS_EXCLUIR')
        self.model.permissoes.veiculosVisualizar = dados.includes('ROLE_VEICULOS_VISUALIZAR')
        self.model.permissoes.veiculosRelatorios = dados.includes('ROLE_VEICULOS_RELATORIOS')
        self.model.permissoes.vendedoresCadastrar = dados.includes('ROLE_VENDEDORES_CADASTRAR')
        self.model.permissoes.vendedoresEditar = dados.includes('ROLE_VENDEDORES_EDITAR')
        self.model.permissoes.vendedoresExcluir = dados.includes('ROLE_VENDEDORES_EXCLUIR')
        self.model.permissoes.vendedoresVisualizar = dados.includes('ROLE_VENDEDORES_VISUALIZAR')
        self.model.permissoes.vendedoresRelatorios = dados.includes('ROLE_VENDEDORES_RELATORIOS')
        self.model.permissoes.produtosCadastrar = dados.includes('ROLE_PRODUTOS_CADASTRAR')
        self.model.permissoes.produtosEditar = dados.includes('ROLE_PRODUTOS_EDITAR')
        self.model.permissoes.produtosExcluir = dados.includes('ROLE_PRODUTOS_EXCLUIR')
        self.model.permissoes.produtosVisualizar = dados.includes('ROLE_PRODUTOS_VISUALIZAR')
        self.model.permissoes.produtosRelatorios = dados.includes('ROLE_PRODUTOS_RELATORIOS')
        self.model.permissoes.servicosCadastrar = dados.includes('ROLE_SERVICOS_CADASTRAR')
        self.model.permissoes.servicosEditar = dados.includes('ROLE_SERVICOS_EDITAR')
        self.model.permissoes.servicosExcluir = dados.includes('ROLE_SERVICOS_EXCLUIR')
        self.model.permissoes.servicosVisualizar = dados.includes('ROLE_SERVICOS_VISUALIZAR')
        self.model.permissoes.servicosRelatorios = dados.includes('ROLE_SERVICOS_RELATORIOS')
        self.model.permissoes.depositosCadastrar = dados.includes('ROLE_DEPOSITOS_CADASTRAR')
        self.model.permissoes.depositosEditar = dados.includes('ROLE_DEPOSITOS_EDITAR')
        self.model.permissoes.depositosExcluir = dados.includes('ROLE_DEPOSITOS_EXCLUIR')
        self.model.permissoes.depositosVisualizar = dados.includes('ROLE_DEPOSITOS_VISUALIZAR')
        self.model.permissoes.depositosRelatorios = dados.includes('ROLE_DEPOSITOS_RELATORIOS')
        self.model.permissoes.movimentacaoEstoqueCadastrar = dados.includes('ROLE_MOVIMENTACAO_ESTOQUE_CADASTRAR')
        self.model.permissoes.movimentacaoEstoqueEditar = dados.includes('ROLE_MOVIMENTACAO_ESTOQUE_EDITAR')
        self.model.permissoes.movimentacaoEstoqueExcluir = dados.includes('ROLE_MOVIMENTACAO_ESTOQUE_EXCLUIR')
        self.model.permissoes.movimentacaoEstoqueVisualizar = dados.includes('ROLE_MOVIMENTACAO_ESTOQUE_VISUALIZAR')
        self.model.permissoes.movimentacaoEstoqueRelatorios = dados.includes('ROLE_MOVIMENTACAO_ESTOQUE_RELATORIOS')
        self.model.permissoes.balancoEstoqueCadastrar = dados.includes('ROLE_BALANCO_ESTOQUE_CADASTRAR')
        self.model.permissoes.balancoEstoqueEditar = dados.includes('ROLE_BALANCO_ESTOQUE_EDITAR')
        self.model.permissoes.balancoEstoqueExcluir = dados.includes('ROLE_BALANCO_ESTOQUE_EXCLUIR')
        self.model.permissoes.balancoEstoqueVisualizar = dados.includes('ROLE_BALANCO_ESTOQUE_VISUALIZAR')
        self.model.permissoes.balancoEstoqueRelatorios = dados.includes('ROLE_BALANCO_ESTOQUE_RELATORIOS')
        self.model.permissoes.fluxoCaixaCadastrar = dados.includes('ROLE_FLUXO_CAIXA_CADASTRAR')
        self.model.permissoes.fluxoCaixaEditar = dados.includes('ROLE_FLUXO_CAIXA_EDITAR')
        self.model.permissoes.fluxoCaixaExcluir = dados.includes('ROLE_FLUXO_CAIXA_EXCLUIR')
        self.model.permissoes.fluxoCaixaVisualizar = dados.includes('ROLE_FLUXO_CAIXA_VISUALIZAR')
        self.model.permissoes.fluxoCaixaRelatorios = dados.includes('ROLE_FLUXO_CAIXA_RELATORIOS')
        self.model.permissoes.contasPagarCadastrar = dados.includes('ROLE_CONTAS_PAGAR_CADASTRAR')
        self.model.permissoes.contasPagarEditar = dados.includes('ROLE_CONTAS_PAGAR_EDITAR')
        self.model.permissoes.contasPagarExcluir = dados.includes('ROLE_CONTAS_PAGAR_EXCLUIR')
        self.model.permissoes.contasPagarVisualizar = dados.includes('ROLE_CONTAS_PAGAR_VISUALIZAR')
        self.model.permissoes.contasPagarRelatorios = dados.includes('ROLE_CONTAS_PAGAR_RELATORIOS')
        self.model.permissoes.contasReceberCadastrar = dados.includes('ROLE_CONTAS_RECEBER_CADASTRAR')
        self.model.permissoes.contasReceberEditar = dados.includes('ROLE_CONTAS_RECEBER_EDITAR')
        self.model.permissoes.contasReceberExcluir = dados.includes('ROLE_CONTAS_RECEBER_EXCLUIR')
        self.model.permissoes.contasReceberVisualizar = dados.includes('ROLE_CONTAS_RECEBER_VISUALIZAR')
        self.model.permissoes.contasReceberRelatorios = dados.includes('ROLE_CONTAS_RECEBER_RELATORIOS')
        self.model.permissoes.bancosCadastrar = dados.includes('ROLE_BANCOS_CADASTRAR')
        self.model.permissoes.bancosEditar = dados.includes('ROLE_BANCOS_EDITAR')
        self.model.permissoes.bancosExcluir = dados.includes('ROLE_BANCOS_EXCLUIR')
        self.model.permissoes.bancosVisualizar = dados.includes('ROLE_BANCOS_VISUALIZAR')
        self.model.permissoes.bancosRelatorios = dados.includes('ROLE_BANCOS_RELATORIOS')
        self.model.permissoes.movimentacaoBancariaCadastrar = dados.includes('ROLE_MOVIMENTACAO_BANCARIA_CADASTRAR')
        self.model.permissoes.movimentacaoBancariaEditar = dados.includes('ROLE_MOVIMENTACAO_BANCARIA_EDITAR')
        self.model.permissoes.movimentacaoBancariaExcluir = dados.includes('ROLE_MOVIMENTACAO_BANCARIA_EXCLUIR')
        self.model.permissoes.movimentacaoBancariaVisualizar = dados.includes('ROLE_MOVIMENTACAO_BANCARIA_VISUALIZAR')
        self.model.permissoes.movimentacaoBancariaRelatorios = dados.includes('ROLE_MOVIMENTACAO_BANCARIA_RELATORIOS')
        self.model.permissoes.movimentacaoBoletosCadastrar = dados.includes('ROLE_MOVIMENTACAO_BOLETOS_CADASTRAR')
        self.model.permissoes.movimentacaoBoletosEditar = dados.includes('ROLE_MOVIMENTACAO_BOLETOS_EDITAR')
        self.model.permissoes.movimentacaoBoletosExcluir = dados.includes('ROLE_MOVIMENTACAO_BOLETOS_EXCLUIR')
        self.model.permissoes.movimentacaoBoletosVisualizar = dados.includes('ROLE_MOVIMENTACAO_BOLETOS_VISUALIZAR')
        self.model.permissoes.movimentacaoBoletosRelatorios = dados.includes('ROLE_MOVIMENTACAO_BOLETOS_RELATORIOS')

        self.model.permissoes.chequesEmitidosCadastrar = dados.includes('ROLE_CHEQUES_EMITIDOS_CADASTRAR')
        self.model.permissoes.chequesEmitidosEditar = dados.includes('ROLE_CHEQUES_EMITIDOS_EDITAR')
        self.model.permissoes.chequesEmitidosExcluir = dados.includes('ROLE_CHEQUES_EMITIDOS_EXCLUIR')
        self.model.permissoes.chequesEmitidosVisualizar = dados.includes('ROLE_CHEQUES_EMITIDOS_VISUALIZAR')
        self.model.permissoes.chequesEmitidosRelatorios = dados.includes('ROLE_CHEQUES_EMITIDOS_RELATORIOS')
        self.model.permissoes.chequesRepasseCadastrar = dados.includes('ROLE_CHEQUES_REPASSE_CADASTRAR')
        self.model.permissoes.chequesRepasseEditar = dados.includes('ROLE_CHEQUES_REPASSE_EDITAR')
        self.model.permissoes.chequesRepasseExcluir = dados.includes('ROLE_CHEQUES_REPASSE_EXCLUIR')
        self.model.permissoes.chequesRepasseVisualizar = dados.includes('ROLE_CHEQUES_REPASSE_VISUALIZAR')
        self.model.permissoes.chequesRepasseRelatorios = dados.includes('ROLE_CHEQUES_REPASSE_RELATORIOS')
        self.model.permissoes.statusChequeCadastrar = dados.includes('ROLE_STATUS_CHEQUE_CADASTRAR')
        self.model.permissoes.statusChequeEditar = dados.includes('ROLE_STATUS_CHEQUE_EDITAR')
        self.model.permissoes.statusChequeExcluir = dados.includes('ROLE_STATUS_CHEQUE_EXCLUIR')
        self.model.permissoes.statusChequeVisualizar = dados.includes('ROLE_STATUS_CHEQUE_VISUALIZAR')
        self.model.permissoes.statusChequeRelatorios = dados.includes('ROLE_STATUS_CHEQUE_RELATORIOS')
        self.model.permissoes.comprasCadastrar = dados.includes('ROLE_COMPRAS_CADASTRAR')
        self.model.permissoes.comprasEditar = dados.includes('ROLE_COMPRAS_EDITAR')
        self.model.permissoes.comprasConfirmar = dados.includes('ROLE_COMPRAS_CONFIRMAR')
        self.model.permissoes.comprasCancelar = dados.includes('ROLE_COMPRAS_CANCELAR')
        self.model.permissoes.comprasVisualizar = dados.includes('ROLE_COMPRAS_VISUALIZAR')
        self.model.permissoes.comprasRelatorios = dados.includes('ROLE_COMPRAS_RELATORIOS')
        self.model.permissoes.analiseCompraCadastrar = dados.includes('ROLE_ANALISE_COMPRA_CADASTRAR')
        self.model.permissoes.analiseCompraEditar = dados.includes('ROLE_ANALISE_COMPRA_EDITAR')
        self.model.permissoes.analiseCompraConfirmar = dados.includes('ROLE_ANALISE_COMPRA_CONFIRMAR')
        self.model.permissoes.analiseCompraCancelar = dados.includes('ROLE_ANALISE_COMPRA_CANCELAR')
        self.model.permissoes.analiseCompraVisualizar = dados.includes('ROLE_ANALISE_COMPRA_VISUALIZAR')
        self.model.permissoes.analiseCompraRelatorios = dados.includes('ROLE_ANALISE_COMPRA_RELATORIOS')
        self.model.permissoes.cotacaoCompraCadastrar = dados.includes('ROLE_COTACAO_COMPRA_CADASTRAR')
        self.model.permissoes.cotacaoCompraEditar = dados.includes('ROLE_COTACAO_COMPRA_EDITAR')
        self.model.permissoes.cotacaoCompraConfirmar = dados.includes('ROLE_COTACAO_COMPRA_CONFIRMAR')
        self.model.permissoes.cotacaoCompraCancelar = dados.includes('ROLE_COTACAO_COMPRA_CANCELAR')
        self.model.permissoes.cotacaoCompraVisualizar = dados.includes('ROLE_COTACAO_COMPRA_VISUALIZAR')
        self.model.permissoes.cotacaoCompraRelatorios = dados.includes('ROLE_COTACAO_COMPRA_RELATORIOS')
        self.model.permissoes.vendasProdutosCadastrar = dados.includes('ROLE_VENDAS_PRODUTOS_CADASTRAR')
        self.model.permissoes.vendasProdutosEditar = dados.includes('ROLE_VENDAS_PRODUTOS_EDITAR')
        self.model.permissoes.vendasProdutosConfirmar = dados.includes('ROLE_VENDAS_PRODUTOS_CONFIRMAR')
        self.model.permissoes.vendasProdutosCancelar = dados.includes('ROLE_VENDAS_PRODUTOS_CANCELAR')
        self.model.permissoes.vendasProdutosVisualizar = dados.includes('ROLE_VENDAS_PRODUTOS_VISUALIZAR')
        self.model.permissoes.vendasProdutosRelatorios = dados.includes('ROLE_VENDAS_PRODUTOS_RELATORIOS')
        self.model.permissoes.devolucaoProdutosCadastrar = dados.includes('ROLE_DEVOLUCAO_PRODUTOS_CADASTRAR')
        self.model.permissoes.devolucaoProdutosEditar = dados.includes('ROLE_DEVOLUCAO_PRODUTOS_EDITAR')
        self.model.permissoes.devolucaoProdutosConfirmar = dados.includes('ROLE_DEVOLUCAO_PRODUTOS_CONFIRMAR')
        self.model.permissoes.devolucaoProdutosCancelar = dados.includes('ROLE_DEVOLUCAO_PRODUTOS_CANCELAR')
        self.model.permissoes.devolucaoProdutosVisualizar = dados.includes('ROLE_DEVOLUCAO_PRODUTOS_VISUALIZAR')
        self.model.permissoes.devolucaoProdutosRelatorios = dados.includes('ROLE_DEVOLUCAO_PRODUTOS_RELATORIOS')
        self.model.permissoes.vendasServicosCadastrar = dados.includes('ROLE_VENDAS_SERVICOS_CADASTRAR')
        self.model.permissoes.vendasServicosEditar = dados.includes('ROLE_VENDAS_SERVICOS_EDITAR')
        self.model.permissoes.vendasServicosConfirmar = dados.includes('ROLE_VENDAS_SERVICOS_CONFIRMAR')
        self.model.permissoes.vendasServicosCancelar = dados.includes('ROLE_VENDAS_SERVICOS_CANCELAR')
        self.model.permissoes.vendasServicosVisualizar = dados.includes('ROLE_VENDAS_SERVICOS_VISUALIZAR')
        self.model.permissoes.vendasServicosRelatorios = dados.includes('ROLE_VENDAS_SERVICOS_RELATORIOS')
        self.model.permissoes.vendasProdutosPdvCadastrar = dados.includes('ROLE_VENDAS_PRODUTOS_PDV_CADASTRAR')
        self.model.permissoes.vendasProdutosPdvEditar = dados.includes('ROLE_VENDAS_PRODUTOS_PDV_EDITAR')
        self.model.permissoes.vendasProdutosPdvConfirmar = dados.includes('ROLE_VENDAS_PRODUTOS_PDV_CONFIRMAR')
        self.model.permissoes.vendasProdutosPdvCancelar = dados.includes('ROLE_VENDAS_PRODUTOS_PDV_CANCELAR')
        self.model.permissoes.vendasProdutosPdvVisualizar = dados.includes('ROLE_VENDAS_PRODUTOS_PDV_VISUALIZAR')
        self.model.permissoes.vendasProdutosPdvRelatorios = dados.includes('ROLE_VENDAS_PRODUTOS_PDV_RELATORIOS')
        self.model.permissoes.configuracaoVendasEditar = dados.includes('ROLE_CONFIGURACAO_VENDAS_EDITAR')
        self.model.permissoes.configuracaoVendasMobileEditar = dados.includes('ROLE_CONFIGURACAO_VENDAS_MOBILE_EDITAR')
        self.model.permissoes.nfeCadastrar = dados.includes('ROLE_NFE_CADASTRAR')
        self.model.permissoes.nfeEditar = dados.includes('ROLE_NFE_EDITAR')
        self.model.permissoes.nfeEnviar = dados.includes('ROLE_NFE_ENVIAR')
        self.model.permissoes.nfeCancelar = dados.includes('ROLE_NFE_CANCELAR')
        self.model.permissoes.nfeEventos = dados.includes('ROLE_NFE_EVENTOS')
        self.model.permissoes.nfeVisualizar = dados.includes('ROLE_NFE_VISUALIZAR')
        self.model.permissoes.nfeRelatorios = dados.includes('ROLE_NFE_RELATORIOS')
        self.model.permissoes.nfceCadastrar = dados.includes('ROLE_NFCE_CADASTRAR')
        self.model.permissoes.nfceEditar = dados.includes('ROLE_NFCE_EDITAR')
        self.model.permissoes.nfceEnviar = dados.includes('ROLE_NFCE_ENVIAR')
        self.model.permissoes.nfceCancelar = dados.includes('ROLE_NFCE_CANCELAR')
        self.model.permissoes.nfceEventos = dados.includes('ROLE_NFCE_EVENTOS')
        self.model.permissoes.nfceVisualizar = dados.includes('ROLE_NFCE_VISUALIZAR')
        self.model.permissoes.nfceRelatorios = dados.includes('ROLE_NFCE_RELATORIOS')
        self.model.permissoes.nfseCadastrar = dados.includes('ROLE_NFSE_CADASTRAR')
        self.model.permissoes.nfseEditar = dados.includes('ROLE_NFSE_EDITAR')
        self.model.permissoes.nfseEnviar = dados.includes('ROLE_NFSE_ENVIAR')
        self.model.permissoes.nfseCancelar = dados.includes('ROLE_NFSE_CANCELAR')
        self.model.permissoes.nfseEventos = dados.includes('ROLE_NFSE_EVENTOS')
        self.model.permissoes.nfseVisualizar = dados.includes('ROLE_NFSE_VISUALIZAR')
        self.model.permissoes.nfseRelatorios = dados.includes('ROLE_NFSE_RELATORIOS')
        self.model.permissoes.mdfeCadastrar = dados.includes('ROLE_MDFE_CADASTRAR')
        self.model.permissoes.mdfeEditar = dados.includes('ROLE_MDFE_EDITAR')
        self.model.permissoes.mdfeEnviar = dados.includes('ROLE_MDFE_ENVIAR')
        self.model.permissoes.mdfeCancelar = dados.includes('ROLE_MDFE_CANCELAR')
        self.model.permissoes.mdfeEventos = dados.includes('ROLE_MDFE_EVENTOS')
        self.model.permissoes.mdfeVisualizar = dados.includes('ROLE_MDFE_VISUALIZAR')
        self.model.permissoes.mdfeRelatorios = dados.includes('ROLE_MDFE_RELATORIOS')
        self.model.permissoes.cteCadastrar = dados.includes('ROLE_CTE_CADASTRAR')
        self.model.permissoes.cteEditar = dados.includes('ROLE_CTE_EDITAR')
        self.model.permissoes.cteEnviar = dados.includes('ROLE_CTE_ENVIAR')
        self.model.permissoes.cteCancelar = dados.includes('ROLE_CTE_CANCELAR')
        self.model.permissoes.cteEventos = dados.includes('ROLE_CTE_EVENTOS')
        self.model.permissoes.cteVisualizar = dados.includes('ROLE_CTE_VISUALIZAR')
        self.model.permissoes.cteRelatorios = dados.includes('ROLE_CTE_RELATORIOS')
        self.model.permissoes.guiaTrafegoCadastrar = dados.includes('ROLE_GUIA_TRAFEGO_CADASTRAR')
        self.model.permissoes.guiaTrafegoEditar = dados.includes('ROLE_GUIA_TRAFEGO_EDITAR')
        self.model.permissoes.guiaTrafegoEnviar = dados.includes('ROLE_GUIA_TRAFEGO_ENVIAR')
        self.model.permissoes.guiaTrafegoCancelar = dados.includes('ROLE_GUIA_TRAFEGO_CANCELAR')
        self.model.permissoes.guiaTrafegoEventos = dados.includes('ROLE_GUIA_TRAFEGO_EVENTOS')
        self.model.permissoes.guiaTrafegoVisualizar = dados.includes('ROLE_GUIA_TRAFEGO_VISUALIZAR')
        self.model.permissoes.guiaTrafegoRelatorios = dados.includes('ROLE_GUIA_TRAFEGO_RELATORIOS')
        self.model.permissoes.mensagensNfeCadastrar = dados.includes('ROLE_MENSAGENS_NFE_CADASTRAR')
        self.model.permissoes.mensagensNfeEditar = dados.includes('ROLE_MENSAGENS_NFE_EDITAR')
        self.model.permissoes.mensagensNfeExcluir = dados.includes('ROLE_MENSAGENS_NFE_EXCLUIR')
        self.model.permissoes.mensagensNfeVisualizar = dados.includes('ROLE_MENSAGENS_NFE_VISUALIZAR')
        self.model.permissoes.mensagensNfeRelatorios = dados.includes('ROLE_MENSAGENS_NFE_RELATORIOS')
        self.model.permissoes.mensagensNfceCadastrar = dados.includes('ROLE_MENSAGENS_NFCE_CADASTRAR')
        self.model.permissoes.mensagensNfceEditar = dados.includes('ROLE_MENSAGENS_NFCE_EDITAR')
        self.model.permissoes.mensagensNfceExcluir = dados.includes('ROLE_MENSAGENS_NFCE_EXCLUIR')
        self.model.permissoes.mensagensNfceVisualizar = dados.includes('ROLE_MENSAGENS_NFCE_VISUALIZAR')
        self.model.permissoes.mensagensNfceRelatorios = dados.includes('ROLE_MENSAGENS_NFCE_RELATORIOS')
        self.model.permissoes.mensagensNfseCadastrar = dados.includes('ROLE_MENSAGENS_NFSE_CADASTRAR')
        self.model.permissoes.mensagensNfseEditar = dados.includes('ROLE_MENSAGENS_NFSE_EDITAR')
        self.model.permissoes.mensagensNfseExcluir = dados.includes('ROLE_MENSAGENS_NFSE_EXCLUIR')
        self.model.permissoes.mensagensNfseVisualizar = dados.includes('ROLE_MENSAGENS_NFSE_VISUALIZAR')
        self.model.permissoes.mensagensNfseRelatorios = dados.includes('ROLE_MENSAGENS_NFSE_RELATORIOS')
        self.model.permissoes.mensagensMdfeCadastrar = dados.includes('ROLE_MENSAGENS_MDFE_CADASTRAR')
        self.model.permissoes.mensagensMdfeEditar = dados.includes('ROLE_MENSAGENS_MDFE_EDITAR')
        self.model.permissoes.mensagensMdfeExcluir = dados.includes('ROLE_MENSAGENS_MDFE_EXCLUIR')
        self.model.permissoes.mensagensMdfeVisualizar = dados.includes('ROLE_MENSAGENS_MDFE_VISUALIZAR')
        self.model.permissoes.mensagensMdfeRelatorios = dados.includes('ROLE_MENSAGENS_MDFE_RELATORIOS')
        self.model.permissoes.mensagensCteCadastrar = dados.includes('ROLE_MENSAGENS_CTE_CADASTRAR')
        self.model.permissoes.mensagensCteEditar = dados.includes('ROLE_MENSAGENS_CTE_EDITAR')
        self.model.permissoes.mensagensCteExcluir = dados.includes('ROLE_MENSAGENS_CTE_EXCLUIR')
        self.model.permissoes.mensagensCteVisualizar = dados.includes('ROLE_MENSAGENS_CTE_VISUALIZAR')
        self.model.permissoes.mensagensCteRelatorios = dados.includes('ROLE_MENSAGENS_CTE_RELATORIOS')
        self.model.permissoes.formasPagamentoCadastrar = dados.includes('ROLE_FORMAS_PAGAMENTO_CADASTRAR')
        self.model.permissoes.formasPagamentoEditar = dados.includes('ROLE_FORMAS_PAGAMENTO_EDITAR')
        self.model.permissoes.formasPagamentoExcluir = dados.includes('ROLE_FORMAS_PAGAMENTO_EXCLUIR')
        self.model.permissoes.formasPagamentoVisualizar = dados.includes('ROLE_FORMAS_PAGAMENTO_VISUALIZAR')
        self.model.permissoes.formasPagamentoRelatorios = dados.includes('ROLE_FORMAS_PAGAMENTO_RELATORIOS')
        self.model.permissoes.codigosNcmsCadastrar = dados.includes('ROLE_CODIGOS_NCMS_CADASTRAR')
        self.model.permissoes.codigosNcmsEditar = dados.includes('ROLE_CODIGOS_NCMS_EDITAR')
        self.model.permissoes.codigosNcmsExcluir = dados.includes('ROLE_CODIGOS_NCMS_EXCLUIR')
        self.model.permissoes.codigosNcmsVisualizar = dados.includes('ROLE_CODIGOS_NCMS_VISUALIZAR')
        self.model.permissoes.codigosNcmsRelatorios = dados.includes('ROLE_CODIGOS_NCMS_RELATORIOS')
        self.model.permissoes.cidadesCadastrar = dados.includes('ROLE_CIDADES_CADASTRAR')
        self.model.permissoes.cidadesEditar = dados.includes('ROLE_CIDADES_EDITAR')
        self.model.permissoes.cidadesExcluir = dados.includes('ROLE_CIDADES_EXCLUIR')
        self.model.permissoes.cidadesVisualizar = dados.includes('ROLE_CIDADES_VISUALIZAR')
        self.model.permissoes.cidadesRelatorios = dados.includes('ROLE_CIDADES_RELATORIOS')
        self.model.permissoes.centrosCustosCadastrar = dados.includes('ROLE_CENTROS_CUSTOS_CADASTRAR')
        self.model.permissoes.centrosCustosEditar = dados.includes('ROLE_CENTROS_CUSTOS_EDITAR')
        self.model.permissoes.centrosCustosExcluir = dados.includes('ROLE_CENTROS_CUSTOS_EXCLUIR')
        self.model.permissoes.centrosCustosVisualizar = dados.includes('ROLE_CENTROS_CUSTOS_VISUALIZAR')
        self.model.permissoes.centrosCustosRelatorios = dados.includes('ROLE_CENTROS_CUSTOS_RELATORIOS')
        self.model.permissoes.conceitosCadastrar = dados.includes('ROLE_CONCEITOS_CADASTRAR')
        self.model.permissoes.conceitosEditar = dados.includes('ROLE_CONCEITOS_EDITAR')
        self.model.permissoes.conceitosExcluir = dados.includes('ROLE_CONCEITOS_EXCLUIR')
        self.model.permissoes.conceitosVisualizar = dados.includes('ROLE_CONCEITOS_VISUALIZAR')
        self.model.permissoes.conceitosRelatorios = dados.includes('ROLE_CONCEITOS_RELATORIOS')
        self.model.permissoes.contasCaixaCadastrar = dados.includes('ROLE_CONTAS_CAIXA_CADASTRAR')
        self.model.permissoes.contasCaixaEditar = dados.includes('ROLE_CONTAS_CAIXA_EDITAR')
        self.model.permissoes.contasCaixaExcluir = dados.includes('ROLE_CONTAS_CAIXA_EXCLUIR')
        self.model.permissoes.contasCaixaVisualizar = dados.includes('ROLE_CONTAS_CAIXA_VISUALIZAR')
        self.model.permissoes.contasCaixaRelatorios = dados.includes('ROLE_CONTAS_CAIXA_RELATORIOS')
        self.model.permissoes.codigoCfopCadastrar = dados.includes('ROLE_CODIGO_CFOP_CADASTRAR')
        self.model.permissoes.codigoCfopEditar = dados.includes('ROLE_CODIGO_CFOP_EDITAR')
        self.model.permissoes.codigoCfopExcluir = dados.includes('ROLE_CODIGO_CFOP_EXCLUIR')
        self.model.permissoes.codigoCfopVisualizar = dados.includes('ROLE_CODIGO_CFOP_VISUALIZAR')
        self.model.permissoes.codigoCfopRelatorios = dados.includes('ROLE_CODIGO_CFOP_RELATORIOS')
        self.model.permissoes.codigoCfopRegrasCadastrar = dados.includes('ROLE_CODIGO_CFOP_REGRAS_CADASTRAR')
        self.model.permissoes.codigoCfopRegrasEditar = dados.includes('ROLE_CODIGO_CFOP_REGRAS_EDITAR')
        self.model.permissoes.codigoCfopRegrasExcluir = dados.includes('ROLE_CODIGO_CFOP_REGRAS_EXCLUIR')
        self.model.permissoes.codigoCfopRegrasVisualizar = dados.includes('ROLE_CODIGO_CFOP_REGRAS_VISUALIZAR')
        self.model.permissoes.codigoCfopRegrasRelatorios = dados.includes('ROLE_CODIGO_CFOP_REGRAS_RELATORIOS')
        self.model.permissoes.planosContasCadastrar = dados.includes('ROLE_PLANOS_CONTAS_CADASTRAR')
        self.model.permissoes.planosContasEditar = dados.includes('ROLE_PLANOS_CONTAS_EDITAR')
        self.model.permissoes.planosContasExcluir = dados.includes('ROLE_PLANOS_CONTAS_EXCLUIR')
        self.model.permissoes.planosContasVisualizar = dados.includes('ROLE_PLANOS_CONTAS_VISUALIZAR')
        self.model.permissoes.planosContasRelatorios = dados.includes('ROLE_PLANOS_CONTAS_RELATORIOS')
        self.model.permissoes.produtosMarcasCadastrar = dados.includes('ROLE_PRODUTOS_MARCAS_CADASTRAR')
        self.model.permissoes.produtosMarcasEditar = dados.includes('ROLE_PRODUTOS_MARCAS_EDITAR')
        self.model.permissoes.produtosMarcasExcluir = dados.includes('ROLE_PRODUTOS_MARCAS_EXCLUIR')
        self.model.permissoes.produtosMarcasVisualizar = dados.includes('ROLE_PRODUTOS_MARCAS_VISUALIZAR')
        self.model.permissoes.produtosMarcasRelatorios = dados.includes('ROLE_PRODUTOS_MARCAS_RELATORIOS')
        self.model.permissoes.produtosGruposCadastrar = dados.includes('ROLE_PRODUTOS_GRUPOS_CADASTRAR')
        self.model.permissoes.produtosGruposEditar = dados.includes('ROLE_PRODUTOS_GRUPOS_EDITAR')
        self.model.permissoes.produtosGruposExcluir = dados.includes('ROLE_PRODUTOS_GRUPOS_EXCLUIR')
        self.model.permissoes.produtosGruposVisualizar = dados.includes('ROLE_PRODUTOS_GRUPOS_VISUALIZAR')
        self.model.permissoes.produtosGruposRelatorios = dados.includes('ROLE_PRODUTOS_GRUPOS_RELATORIOS')
        self.model.permissoes.produtosSubGruposCadastrar = dados.includes('ROLE_PRODUTOS_SUB_GRUPOS_CADASTRAR')
        self.model.permissoes.produtosSubGruposEditar = dados.includes('ROLE_PRODUTOS_SUB_GRUPOS_EDITAR')
        self.model.permissoes.produtosSubGruposExcluir = dados.includes('ROLE_PRODUTOS_SUB_GRUPOS_EXCLUIR')
        self.model.permissoes.produtosSubGruposVisualizar = dados.includes('ROLE_PRODUTOS_SUB_GRUPOS_VISUALIZAR')
        self.model.permissoes.produtosSubGruposRelatorios = dados.includes('ROLE_PRODUTOS_SUB_GRUPOS_RELATORIOS')
        self.model.permissoes.produtosCoresCadastrar = dados.includes('ROLE_PRODUTOS_CORES_CADASTRAR')
        self.model.permissoes.produtosCoresEditar = dados.includes('ROLE_PRODUTOS_CORES_EDITAR')
        self.model.permissoes.produtosCoresExcluir = dados.includes('ROLE_PRODUTOS_CORES_EXCLUIR')
        self.model.permissoes.produtosCoresVisualizar = dados.includes('ROLE_PRODUTOS_CORES_VISUALIZAR')
        self.model.permissoes.produtosCoresRelatorios = dados.includes('ROLE_PRODUTOS_CORES_RELATORIOS')
        self.model.permissoes.produtosTamanhosCadastrar = dados.includes('ROLE_PRODUTOS_TAMANHOS_CADASTRAR')
        self.model.permissoes.produtosTamanhosEditar = dados.includes('ROLE_PRODUTOS_TAMANHOS_EDITAR')
        self.model.permissoes.produtosTamanhosExcluir = dados.includes('ROLE_PRODUTOS_TAMANHOS_EXCLUIR')
        self.model.permissoes.produtosTamanhosVisualizar = dados.includes('ROLE_PRODUTOS_TAMANHOS_VISUALIZAR')
        self.model.permissoes.produtosTamanhosRelatorios = dados.includes('ROLE_PRODUTOS_TAMANHOS_RELATORIOS')
        self.model.permissoes.produtosUnidadesCadastrar = dados.includes('ROLE_PRODUTOS_UNIDADES_CADASTRAR')
        self.model.permissoes.produtosUnidadesEditar = dados.includes('ROLE_PRODUTOS_UNIDADES_EDITAR')
        self.model.permissoes.produtosUnidadesExcluir = dados.includes('ROLE_PRODUTOS_UNIDADES_EXCLUIR')
        self.model.permissoes.produtosUnidadesVisualizar = dados.includes('ROLE_PRODUTOS_UNIDADES_VISUALIZAR')
        self.model.permissoes.produtosUnidadesRelatorios = dados.includes('ROLE_PRODUTOS_UNIDADES_RELATORIOS')
        self.model.permissoes.produtosDepartamentosCadastrar = dados.includes('ROLE_PRODUTOS_DEPARTAMENTOS_CADASTRAR')
        self.model.permissoes.produtosDepartamentosEditar = dados.includes('ROLE_PRODUTOS_DEPARTAMENTOS_EDITAR')
        self.model.permissoes.produtosDepartamentosExcluir = dados.includes('ROLE_PRODUTOS_DEPARTAMENTOS_EXCLUIR')
        self.model.permissoes.produtosDepartamentosVisualizar = dados.includes('ROLE_PRODUTOS_DEPARTAMENTOS_VISUALIZAR')
        self.model.permissoes.produtosDepartamentosRelatorios = dados.includes('ROLE_PRODUTOS_DEPARTAMENTOS_RELATORIOS')
        self.model.permissoes.produtosTabelasPrecosCadastrar = dados.includes('ROLE_PRODUTOS_TABELAS_PRECOS_CADASTRAR')
        self.model.permissoes.produtosTabelasPrecosEditar = dados.includes('ROLE_PRODUTOS_TABELAS_PRECOS_EDITAR')
        self.model.permissoes.produtosTabelasPrecosExcluir = dados.includes('ROLE_PRODUTOS_TABELAS_PRECOS_EXCLUIR')
        self.model.permissoes.produtosTabelasPrecosVisualizar = dados.includes('ROLE_PRODUTOS_TABELAS_PRECOS_VISUALIZAR')
        self.model.permissoes.produtosTabelasPrecosRelatorios = dados.includes('ROLE_PRODUTOS_TABELAS_PRECOS_RELATORIOS')
        self.model.permissoes.unidadesNegocioCadastrar = dados.includes('ROLE_UNIDADES_NEGOCIO_CADASTRAR')
        self.model.permissoes.unidadesNegocioEditar = dados.includes('ROLE_UNIDADES_NEGOCIO_EDITAR')
        self.model.permissoes.unidadesNegocioExcluir = dados.includes('ROLE_UNIDADES_NEGOCIO_EXCLUIR')
        self.model.permissoes.unidadesNegocioVisualizar = dados.includes('ROLE_UNIDADES_NEGOCIO_VISUALIZAR')
        self.model.permissoes.unidadesNegocioRelatorios = dados.includes('ROLE_UNIDADES_NEGOCIO_RELATORIOS')
        self.model.permissoes.tiposContatosCadastrar = dados.includes('ROLE_TIPOS_CONTATOS_CADASTRAR')
        self.model.permissoes.tiposContatosEditar = dados.includes('ROLE_TIPOS_CONTATOS_EDITAR')
        self.model.permissoes.tiposContatosExcluir = dados.includes('ROLE_TIPOS_CONTATOS_EXCLUIR')
        self.model.permissoes.tiposContatosVisualizar = dados.includes('OLE_TIPOS_CONTATOS_VISUALIZAR')
        self.model.permissoes.tiposContatosRelatorios = dados.includes('OLE_TIPOS_CONTATOS_RELATORIOS')
        self.model.permissoes.tiposEnderecosCadastrar = dados.includes('OLE_TIPOS_ENDERECOS_CADASTRAR')
        self.model.permissoes.tiposEnderecosEditar = dados.includes('ROLE_TIPOS_ENDERECOS_EDITAR')
        self.model.permissoes.tiposEnderecosExcluir = dados.includes('ROLE_TIPOS_ENDERECOS_EXCLUIR')
        self.model.permissoes.tiposEnderecosVisualizar = dados.includes('OLE_TIPOS_ENDERECOS_VISUALIZAR')
        self.model.permissoes.tiposEnderecosRelatorios = dados.includes('OLE_TIPOS_ENDERECOS_RELATORIOS')
        self.model.permissoes.tiposInteracoesCadastrar = dados.includes('OLE_TIPOS_INTERACOES_CADASTRAR')
        self.model.permissoes.tiposInteracoesEditar = dados.includes('ROLE_TIPOS_INTERACOES_EDITAR')
        self.model.permissoes.tiposInteracoesExcluir = dados.includes('ROLE_TIPOS_INTERACOES_EXCLUIR')
        self.model.permissoes.tiposInteracoesVisualizar = dados.includes('ROLE_TIPOS_INTERACOES_VISUALIZAR')
        self.model.permissoes.tiposInteracoesRelatorios = dados.includes('ROLE_TIPOS_INTERACOES_RELATORIOS')
        self.model.permissoes.motivosCancelamentoCadastrar = dados.includes('ROLE_MOTIVOS_CANCELAMENTO_CADASTRAR')
        self.model.permissoes.motivosCancelamentoEditar = dados.includes('ROLE_MOTIVOS_CANCELAMENTO_EDITAR')
        self.model.permissoes.motivosCancelamentoExcluir = dados.includes('ROLE_MOTIVOS_CANCELAMENTO_EXCLUIR')
        self.model.permissoes.motivosCancelamentoVisualizar = dados.includes('ROLE_MOTIVOS_CANCELAMENTO_VISUALIZAR')
        self.model.permissoes.motivosCancelamentoRelatorios = dados.includes('ROLE_MOTIVOS_CANCELAMENTO_RELATORIOS')
        self.model.permissoes.motivosDevolucaoCadastrar = dados.includes('ROLE_MOTIVOS_DEVOLUCAO_CADASTRAR')
        self.model.permissoes.motivosDevolucaoEditar = dados.includes('ROLE_MOTIVOS_DEVOLUCAO_EDITAR')
        self.model.permissoes.motivosDevolucaoExcluir = dados.includes('ROLE_MOTIVOS_DEVOLUCAO_EXCLUIR')
        self.model.permissoes.motivosDevolucaoVisualizar = dados.includes('ROLE_MOTIVOS_DEVOLUCAO_VISUALIZAR')
        self.model.permissoes.motivosDevolucaoRelatorios = dados.includes('ROLE_MOTIVOS_DEVOLUCAO_RELATORIOS')
        self.model.permissoes.motivosInteracoesCadastrar = dados.includes('ROLE_MOTIVOS_INTERACOES_CADASTRAR')
        self.model.permissoes.motivosInteracoesEditar = dados.includes('ROLE_MOTIVOS_INTERACOES_EDITAR')
        self.model.permissoes.motivosInteracoesExcluir = dados.includes('ROLE_MOTIVOS_INTERACOES_EXCLUIR')
        self.model.permissoes.motivosInteracoesVisualizar = dados.includes('ROLE_MOTIVOS_INTERACOES_VISUALIZAR')
        self.model.permissoes.motivosInteracoesRelatorios = dados.includes('ROLE_MOTIVOS_INTERACOES_RELATORIOS')
        self.model.permissoes.usuarioCadastrar = dados.includes('ROLE_USUARIO_CADASTRAR')
        self.model.permissoes.usuarioEditar = dados.includes('ROLE_USUARIO_EDITAR')
        self.model.permissoes.usuarioExcluir = dados.includes('ROLE_USUARIO_EXCLUIR')
        self.model.permissoes.usuarioVisualizar = dados.includes('ROLE_USUARIO_VISUALIZAR')
        self.model.permissoes.usuarioRelatorios = dados.includes('ROLE_USUARIO_RELATORIOS')
        self.model.permissoes.empresaCadastrar = dados.includes('ROLE_EMPRESA_CADASTRAR')
        self.model.permissoes.empresaEditar = dados.includes('ROLE_EMPRESA_EDITAR')
        self.model.permissoes.empresaExcluir = dados.includes('ROLE_EMPRESA_EXCLUIR')
        self.model.permissoes.empresaVisualizar = dados.includes('ROLE_EMPRESA_VISUALIZAR')
        self.model.permissoes.empresaRelatorios = dados.includes('ROLE_EMPRESA_RELATORIOS')
      })
    },
    modificarSenha: function () {
      console.log('modifica')
      this.model.modificaSenha = true
    },
    salvar: function () {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          console.log(JSON.stringify(self.model))
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$store.state.token
            }
          }
          var url = '/api/usuarios/salvar'
          axios.post(url, JSON.stringify(self.model), config)
          .then(function (response) {
            console.log(response)
            if (response.data === 'OK') {
              self.$toastr('success', 'Usuário gravado com sucesso.', 'Atenção')
              self.$router.replace('/usuarios')
            }
          })
          .catch(function (error) {
            console.log(error)
          })
        } else {
          this.$toastr('error', 'Complete os campos destacados.', 'Atenção')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/usuarios/UsuariosEditar.vue